<template lang="pug">
  .component-selectize-vehicle
    selectize(v-if="options",
      ref="selectize",
      :selectedValue="selectedValue",
      :options="options",
      value-field="id",
      :maxItems="maxItems" label-field="Intervention request",
      :items="items" :searchField="searchableFields",
      :optionTemplate="optionTemplate", :disabled="disabled",
      :renderTemplate="renderTemplate",
      @itemAdded="optionSelected",
      @itemRemoved="optionRemoved",
      placeholder="Intervention requests")
</template>

<script>
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
import BaseSelectize from './BaseSelectize'
import Selectize from '../../../Selectize'

export default {
  name: 'SelectizeInterventionRequest',
  extends: BaseSelectize,
  components: {Selectize},
  data() {
    return {
      searchableFields: [
        'id',
        'status',
        'type',
        'description',
      ],
    }
  },
  created() {
    KeplerBackofficeSdk.maintenanceRequest.list(1, -1).all({}, (data) => {
      this.options = data.items
    })
  },
  methods: {
    optionTemplate(item, escape) {
      return `<div><div><small>IR${item.id} ${item.status} ${item.type}</small></div><div>V${item.vehicle.id} ${item.vehicle.brand} ${item.vehicle.model}</div> <div><small>${item.vehicle.plate}</small></div></div>`

    },
    renderTemplate(item, escape) {
      return `<div><div>IR${item.id} ${item.status}</div></div>`
    },
    optionsLoader() {

    },
    clearSelected() {
      this.$refs.selectize.clearSelected()
    }
  },
  props: ['selectedValue', 'disabledSlot', 'archived']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeInterventionRequest.vue?21fc2d39